import { useState } from "react";
import { ButtonSubmit } from "../ButtonSubmit";
import { InputGlobal } from "../InputGlobal";
import { validateName } from "../../helpers/index";
// import { VideoMobile } from "../VideoMobile";

import "./Name.scss";

export const Name = ({ data, setData, nextStep }) => {
  const [errorName, setErrorName] = useState(null);

  const handlerSubmit = (e) => {
    e.preventDefault();

    const { status, error } = validateName(data.first_name);

    if (!status) {
      setErrorName(error);
    } else {
      nextStep();
    }
  };

  const hadndleAddName = (e) => {
    setErrorName(null);
    setData({ ...data, first_name: e.target.value });
  };

  return (
    <div className="global__wrapper">
      {/* <VideoMobile /> */}
      <div className="name__text">
        <p>Oh, we know people you might like!</p>
      </div>
      <form onSubmit={handlerSubmit} className="form__global">
        <h3 className="title__global">What’s your name?</h3>
        <div className="has-float-label">
          <InputGlobal
            className={"input__global" + (errorName ? " error" : "")}
            onChange={(e) => hadndleAddName(e)}
            name={"name"}
            placeholder={"Your name"}
            type={"text"}
            id={"name"}
          />
          <label htmlFor="name" className={errorName ? "error" : ""}>
            Your name
          </label>
          {errorName && <p className="error-text">{errorName}</p>}
        </div>

        <ButtonSubmit className={"button"} text={"Continue"} />
      </form>
    </div>
  );
};
